import React, { ReactElement } from 'react';
import Card from '../../../../../../components/card/card.component';
import Table from '../../../../../../components/table/table.component';
import TableHead from '../../../../../../components/table-head/table-head.component';
import TableBody from '../../../../../../components/table-body/table-body.component';
import TableRow from '../../../../../../components/table-row/table-row.component';
import TableCell from '../../../../../../components/table-cell/table-cell.component';
import List from '../../../../../../components/list/list.component';
import ListItem from '../../../../../../components/list-item/list-item.component';
import ListItemText from '../../../../../../components/list-item-text/list-item-text.component';
import Button from '../../../../../../components/button/button.component';
import SinglePageTab from '../../../../../app/common/single-page-tab/single-page-tab.component';
import useScreenSmall from '../../../../../../hooks/use-screen-small';

const SettingsUserAccountActivity: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isEditMode,
    isRightDrawerOpen,
    formError,
    userData,
    onCancelForm,
    onSubmitForm,
    onCloseUserSessions,
  } = props;

  const isSmallScreen: boolean = useScreenSmall();

  const userAccountOperations: UserAccountOperation[] = userData ? userData.userAccountOperations : [];

  return (
    <SinglePageTab
      isScrollable
      withNoPadding
      withNoButtonBlock
      isSaving={isSaving}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isRightDrawerOpen={isRightDrawerOpen}
      isEmpty={!userAccountOperations || !userAccountOperations.length}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      {
        userAccountOperations && !!userAccountOperations.length && (
          <Card isFlat isContainer>
            <Button isText isActive isDefault onClick={onCloseUserSessions}>
              Terminate All User Sessions
            </Button>
          </Card>
        )
      }
      {
        !isSmallScreen && (
          <Table withStickyHeader>
            <TableHead isSubHeader>
              <TableRow>
                <TableCell width="30%">
                  Date/Time
                </TableCell>
                <TableCell>
                  Operation
                </TableCell>
                <TableCell width="50%">
                  Details
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody isPlain withZebraRows withHeaderColumn>
              {
                userAccountOperations.map((userAccountOperationItem: UserAccountOperation): ReactElement => (
                  <TableRow key={userAccountOperationItem.id}>
                    <TableCell>
                      {userAccountOperationItem.createdDate}
                    </TableCell>
                    <TableCell>
                      {userAccountOperationItem.title}
                    </TableCell>
                    <TableCell>
                      {userAccountOperationItem.additionalData}
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        )
      }
      {
        isSmallScreen && (
          <List>
            {
              userAccountOperations.map((userAccountOperationItem: UserAccountOperation): ReactElement => (
                <ListItem key={userAccountOperationItem.id}>
                  <ListItemText isBlock>
                    {userAccountOperationItem.title}
                  </ListItemText>
                  <ListItemText
                    isBlock
                    isBlockRight
                    subText={`${userAccountOperationItem.createdDate}. ${userAccountOperationItem.additionalData}`}
                  />
                </ListItem>
              ))
            }
          </List>
        )
      }
    </SinglePageTab>
  );
});

export default SettingsUserAccountActivity;
